module.exports = __webpack_public_path__ + "b6224015d59e68ba7031c37519ceffaf.jpg";